<div class="subject-permissions-container">
    <ng-container *ngIf="assignments|async as assignments; else loadingAssignments">
        <app-permission-assignments *ngIf="assignments.length"
                                    [readOnly]="true"
                                    [hideSubject]="true"
                                    [assignments]="assignments">
        </app-permission-assignments>
        <div *ngIf="!assignments.length" fxLayout="row" fxLayoutAlign="center" class="mt-24 mb-16">
            {{'No assignments found'|i18n}}
        </div>
    </ng-container>
</div>

<ng-template #loadingAssignments>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-24 mb-16">
        <mat-spinner diameter="20"></mat-spinner>
        <span class="pl-8">{{'Loading permission assignments'|i18n}}...</span>
    </div>
</ng-template>
